import React, {Fragment, useEffect, useState} from "react";
import Api from "../../Api";
import {InputHelper, MultipleField, Select} from "../../Components/Utils/FieldsHelper";
import {FormattedMessage} from "react-intl";

import Modal from "../../Components/Utils/Modal";
import Button from "../../Components/Utils/UI/Button";
import Loader from "../../Components/Utils/Loader";

import classes from "./styles.module.css";

function Security({token, onMessage, requires2FASetup, clear2FASetupFlag, authorize, isRemember}) {

    const [isLoading, setIsLoading] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);

    const [ipAccessList, setIpAccessList] = useState([""])
    const [initIpAccessList, setInitIpAccessList] = useState([""]);

    const allAuthTypes = [
        {displayName: "E-mail", isEnabled: true, id: "email"},
        {displayName: "Google Authenticator", isEnabled: true, id: "gauth"},
        {displayName: "SMS", isEnabled: true, id: "sms"}];

    const [authTypeList, setAuthTypeList] = useState(allAuthTypes);

    const [currentAuthType, setCurrentAuthType] = useState(null);

    const [currentOTPData, setCurrentOTPData] = useState({isMFAEnabled: false, OTPEmail: "", OTPPhoneNumber: ""});
    const [updateOTPData, setUpdateOTPData] = useState(null);

    const [otpCodeSend, setOTPCodeSend] = useState(false);
    const [otpCode, setOTPCode] = useState("");
    const [otpText, setOTPText] = useState("");

    const [otpEmail, setOTPEmail] = useState("");
    const [otpPhoneNumber, setOTPPhoneNumber] = useState("");

    const [gAuth, setGAuth] = useState({qrCode: null, secret: null});


    useEffect(() => {
        new Api({token}).getUserData().then(r => {
            setIpAccessList(r.ipAccessList.length ? r.ipAccessList : [""]);
            setInitIpAccessList(r.ipAccessList.length ? r.ipAccessList : [""]);
        });

        new Api({token}).getOTPData().then(r => {
            // Фильтруем доступные провайдеры на основе ответа сервера
            if (r.availableProviders && Array.isArray(r.availableProviders)) {
                setAuthTypeList(allAuthTypes.filter(type => r.availableProviders.includes(type.id)));
            }
            setCurrentAuthType(allAuthTypes.find(type => type.id === r.OTPProvider));
            setCurrentOTPData(r);
        })
    }, [])

    function onSetAuthType(type) {
        setCurrentAuthType(type);

        if (type.id === "gauth") {

            setIsLoading(true);

            new Api({token}).setOTPUpdate({isMFAEnabled: true, OTPProvider: "gauth"}).then(r => {

                if (r.status === 200) {
                    setGAuth(r.data);
                    setIsLoading(false);
                }
            })
        }
    }

    function onAuthAction(options) {

        let provider = currentOTPData.OTPProvider ? currentOTPData.OTPProvider : options.OTPProvider;

        switch (provider) {
            case "email":
                setOTPText(() => <FormattedMessage id="Profile.text.changeOTPEmail"
                                                   values={{email: <b>{currentOTPData.OTPEmail}</b>}}
                                                   defaultMessage="Для подтверждения операции необходимо ввести одноразовый пароль."/>)
                break;
            case "gauth":
                setOTPText(() => <FormattedMessage id="Profile.text.changeOTPGAuth"
                                                   defaultMessage="Для подтверждения операции необходимо ввести одноразовый пароль."/>)
                break;
            case "sms":
                setOTPText(() => <FormattedMessage id="Profile.text.changeOTPPhone"
                                                   values={{phone: <b>{currentOTPData.OTPPhoneNumber}</b>}}
                                                   defaultMessage="Для подтверждения операции необходимо ввести одноразовый пароль."/>)
                break;
            default:
        }

        if (options.OTPProvider === "gauth") {
            setIsOpenModal(true);
            setOTPCodeSend(true);
            setUpdateOTPData(options);

            return null;
        }

        new Api({token}).setOTPUpdate(options).then(r => {

            if (r.status === 400) {
                if (r.data.code === "200") {
                    onMessage({type: "error", message: r.data.message});
                    setUpdateOTPData(options);
                } else {
                    onMessage({type: "error", message: r.statusText});
                }

                return null;
            }

            if (r.status === 200) {
                setIsOpenModal(true);
                setOTPCodeSend(true);
                setUpdateOTPData(options);
            }
        })
    }

    function onModalClose() {
        setIsOpenModal(false);
        setIsLoading(false);
    }

    function saveChanges() {

        if (otpCode) {
            new Api({token}).setOTPUpdate({...updateOTPData, code: otpCode}).then(r => {

                setIsLoading(true);
                setOTPCode("");

                if (r.status === 400) {
                    onMessage({type: "error", message: r.statusText});
                    setIsLoading(false);
                    return null;
                }

                if (r.status === 200) {
                    if (r.data.isMFAEnabled) {
                        onMessage({type: "success", message: "Двухфакторная аутентификация подключена"});
                        setCurrentOTPData(r.data);
                        setOTPEmail("");
                        setOTPPhoneNumber("");
                        setGAuth({qrCode: null, secret: null});
                        setIsLoading(false);
                        setIsOpenModal(false);

                        // Если сервер вернул новый токен (после сброса requires2FASetup) — обновляем
                        if (r.data.token && authorize) {
                            authorize(r.data.token, isRemember);
                        } else if (requires2FASetup && clear2FASetupFlag) {
                            // Fallback: сбрасываем флаг только в React state
                            clear2FASetupFlag();
                        }
                    } else {
                        onMessage({type: "success", message: "Двухфакторная аутентификация отключена"});
                        setCurrentAuthType(null);
                        setCurrentOTPData({
                            ...currentOTPData,
                            isMFAEnabled: r.isMFAEnabled,
                            OTPEmail: "",
                            OTPPhoneNumber: ""
                        });
                        setIsLoading(false);
                        setIsOpenModal(false);
                    }
                }
            });
        }
    }

    return (
        <Fragment>

            <Modal title="Изменение данных" isOpen={isOpenModal} onClose={() => onModalClose()}
                   onConfirm={() => saveChanges()} isConfirm>

                {ipAccessList.length !== initIpAccessList.length &&
                    <p className={classes.ModalText}>

                        {ipAccessList.join('').replace(/[\s.,%]/g, '').length !== 0 ?
                            <FormattedMessage
                                id="Profile.text.changeIpAccessList"
                                values={{ipAccessList: <b>{ipAccessList.join(', ')}</b>}}
                                defaultMessage="Список разрешенных IP-адресов был изменен. После подтверждения личный кабинет будет доступен только с адресов: {ipAccessList}."
                            />
                            :
                            <FormattedMessage
                                id="Profile.text.changeIpAccessListClean"
                                defaultMessage="Список разрешенных IP-адресов был изменен. После подтверждения личный кабинет будет доступен со всех адресов без ограничений."
                            />
                        }
                    </p>
                }

                {otpCodeSend && (
                    <Fragment>
                        <p className={classes.ModalText}>{otpText}</p>

                        <div className={classes.ModalInputWrap}>
                            <InputHelper
                                onChange={(name, value) => setOTPCode(value)}
                                value={otpCode}
                                placeholder={"••••••"}
                                fieldName={"otpCode"}
                                label={"FieldsHelper.label.otpCode"}
                                changeRegexp={/[^0-9A-Za-z]+/g}
                                blurRegexp={/^[0-9A-Za-z]+$/g}
                                changeMessage={"FieldsHelper.error.onlyLettersNumbersOTPCode"}
                                blurMessage={"FieldsHelper.error.checkOTPCode"}
                                isDisabled={isLoading}
                                autoComplete="off"
                                isUppercase
                            />
                        </div>
                    </Fragment>
                )}

            </Modal>

            <div className={classes.Column}>
                <h3 className={classes.Title}>Двухфакторная аутентификация</h3>

                <p className={classes.Text}>При включении двухфакторной аутентификации при авторизации будут запрошены
                    дополнительные данные.</p>

                <div className={classes.InputWrap}>
                    <Select
                        onChange={onSetAuthType}
                        onCleanCurrentValue={() => onAuthAction({isMFAEnabled: false})}
                        values={authTypeList}
                        selectedValue={currentAuthType}
                        label={"FieldsHelper.label.authentication"}
                        placeholder={"FieldsHelper.label.authenticationSelect"}
                        isLoading={isLoading || currentOTPData.isMFAEnabled}
                        isClean={currentOTPData.isMFAEnabled}
                        isCleanLabel={"Отключить"}
                        fieldStatus={"isEnabled"}
                        fieldName={"displayName"}
                    />
                </div>

                <div className={classes.InputWrap}>
                    <MultipleField
                        label={'FieldsHelper.label.IPAccessRestriction'}
                        width={230}
                        placeholder={"0.0.0.0"}
                        fieldName={"ipAccessList"}
                        values={ipAccessList}
                        onChange={(name, value) => setIpAccessList(value)}
                        changeRegexp={/[^0-9./]+/g}
                        blurRegexp={/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}[/]*\d{1,2}$/}
                        changeMessage={"FieldsHelper.error.onlyIpSymbols"}
                        blurMessage={"FieldsHelper.error.checkIpSymbols"}
                        autoComplete={"off"}
                    />
                </div>
            </div>

            <div className={classes.Column}>
                {currentAuthType &&
                    <div className={classes.InputWrap}>
                        {currentAuthType.id === "email" &&
                            <Fragment>
                                <h3 className={classes.Title}>Электронная почта</h3>

                                <p className={classes.Text}>Одноразовый пароль будет приходить на указанный email-адрес.
                                    При частых запросах сообщения могут попадать в SPAM.</p>

                                <InputHelper
                                    onChange={(name, value) => setOTPEmail(value)}
                                    value={otpEmail}
                                    placeholder={Boolean(currentOTPData.OTPEmail) ? currentOTPData.OTPEmail : "example@email.ru"}
                                    fieldName={"authEmail"}
                                    label={"FieldsHelper.label.email"}
                                    changeRegexp={/[^A-Za-z0-9\s_@.]+/g}
                                    blurRegexp={/^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/}
                                    changeMessage={"FieldsHelper.error.charactersEmail"}
                                    blurMessage={"FieldsHelper.error.checkEmail"}
                                    isDisabled={isLoading}
                                    readonly={currentOTPData.isMFAEnabled}
                                    autoComplete="off"
                                />

                                {!currentOTPData.isMFAEnabled &&
                                    <Button label={"Profile.btn.connectOTP"} onClick={() => onAuthAction({
                                        isMFAEnabled: true,
                                        OTPProvider: "email",
                                        OTPEmail: otpEmail
                                    })} icon={"document-edit"} isLoading={isLoading}/>}
                            </Fragment>
                        }

                        {currentAuthType.id === "sms" &&
                            <Fragment>
                                <h3 className={classes.Title}>SMS сообщение</h3>

                                <p className={classes.Text}>Одноразовый пароль будет приходить в SMS-сообщении на
                                    указанный номер телефона.</p>

                                <InputHelper
                                    onChange={(name, value) => setOTPPhoneNumber(value)}
                                    value={otpPhoneNumber}
                                    placeholder={Boolean(currentOTPData.OTPPhoneNumber) ? "+" + currentOTPData.OTPPhoneNumber : "+79175744444"}
                                    fieldName={"authPhone"}
                                    label={"FieldsHelper.label.phone"}
                                    changeRegexp={/[^0-9+]+/g}
                                    blurRegexp={/^[+]\d+$/g}
                                    changeMessage={"FieldsHelper.error.onlyNumbersPhone"}
                                    blurMessage={"FieldsHelper.error.checkPhone"}
                                    isDisabled={isLoading}
                                    autoComplete="off"
                                    readonly={currentOTPData.isMFAEnabled}
                                />

                                {!currentOTPData.isMFAEnabled &&
                                    <Button label={"Profile.btn.connectOTP"} onClick={() => onAuthAction({
                                        isMFAEnabled: true,
                                        OTPProvider: "sms",
                                        OTPPhoneNumber: otpPhoneNumber
                                    })} icon={"document-edit"} isLoading={isLoading}/>}
                            </Fragment>
                        }

                        {currentAuthType.id === "gauth" &&
                            <Fragment>
                                <h3 className={classes.Title}>Google Authenticator</h3>

                                <p className={classes.Text}>Установите приложение Google Authenticator из Google Play
                                    или App Store и используйте одноразовые пароли сгенерированные в нем.</p>

                                {isLoading ? <Loader/>
                                    :
                                    gAuth.qrCode &&
                                    <Fragment>
                                        <div className={classes.GAuthWrap}>
                                            <div>
                                                <img src={gAuth.qrCode} alt={"qrCode"} title={"qrCode"} width={150}
                                                     height={150}/>
                                            </div>
                                            <div>

                                                {!currentOTPData.isMFAEnabled &&
                                                    <Button label={"Profile.btn.connectOTP"}
                                                            onClick={() => onAuthAction({
                                                                isMFAEnabled: true,
                                                                OTPProvider: "gauth"
                                                            })} icon={"document-edit"} isLoading={isLoading}/>}
                                            </div>
                                        </div>

                                        <label>Секрктный код</label>
                                        <p>{gAuth.secret}</p>
                                    </Fragment>
                                }

                            </Fragment>
                        }
                    </div>
                }
            </div>
        </Fragment>
    )
}

export default Security;


// WEBPACK FOOTER //
// ./src/PagesOfUser/Profile/Security.js